/** @jsx jsx */
import { jsx, Box, Flex } from 'theme-ui';
import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

// Types
import { CTA } from '../../@types/cta';

// Styles
import { baseStyle } from './style';

// Components
import BackgroundImage from 'gatsby-background-image';
import CTAButton from '../ctaButton';
import Text, { TEXT_TYPES } from '../text';

export interface SmallBannerProps {
  className?: string;
  backgroundImage?: ImageType;
  backgroundMobileImage?: ImageType;
  cta?: CTA;
  text: string;
}

const SmallBanner: FunctionComponent<SmallBannerProps> = React.memo(
  ({ className, backgroundImage, backgroundMobileImage, cta, text }) => {
    const content = React.useMemo(
      () => (
        <Flex sx={baseStyle.mainFlexContainer}>
          <Flex sx={baseStyle.flexContainer}>
            <Text type={TEXT_TYPES.MENU} sx={baseStyle.text}>
              {text}
            </Text>
            <Box>
              <CTAButton type="link" cta={cta} sx={baseStyle.cta}>
                {cta?.label}
              </CTAButton>
            </Box>
          </Flex>
        </Flex>
      ),
      [],
    );

    return (
      <Box
        className={classNames('SmallBanner', className)}
        sx={baseStyle.mainContainer}
      >
        {backgroundImage ? (
          <Box sx={baseStyle.backgroundImageContainer}>
            <BackgroundImage
              fluid={backgroundImage.localFile?.childImageSharp?.fluid}
              sx={baseStyle.mainBackgroundImage}
            >
              {content}
            </BackgroundImage>
            <BackgroundImage
              fluid={backgroundMobileImage.localFile?.childImageSharp?.fluid}
              sx={baseStyle.mainMobileBackgroundImage}
            >
              {content}
            </BackgroundImage>
          </Box>
        ) : (
          content
        )}
      </Box>
    );
  },
);

export default SmallBanner;
